/** Minimal address shape accepted by {@link formatAddress}. */
export interface FormattableAddress {
  streetName?: string | null;
  buildingNumber?: string | null;
  city?: string | null;
  postalCode?: string | null;
  countryCode?: string | null;
}

/**
 * Formats an address as a compact single-line string: "Street Name 12, 11000 City, CC".
 * Missing parts are skipped; returns an empty string when nothing is filled.
 */
import { compact } from 'es-toolkit';

export function formatAddress(address?: FormattableAddress | null): string {
  if (!address) return '';
  const street = compact([address.streetName, address.buildingNumber]).join(' ').trim();
  const cityLine = compact([address.postalCode, address.city]).join(' ').trim();
  return compact([street, cityLine, address.countryCode?.trim()]).join(', ');
}
